/* ============================================================
   KICK SPEED SIZE KIT – assets/ks-size-quick.js
   Loaded by snippets/ks-size-quick.liquid. Drives:
     [data-kss]  Shop by size   (sections/ks-size-teaser.liquid)
     [data-ksg]  Size guide     (sections/ks-size-guide.liquid)
   Uses window.KSFinder (snippets/ks-finder-core.liquid) for everything
   that has to agree with the size finder, the size helper and the Kick
   Dock: the charts, sizeFor(), the fits, saved sizes, last measurement
   and the model list (KSFinder.catalog). All texts go in with textContent.
   ============================================================ */
(function () {
  'use strict';
  if (window.__ksSizeKit) return;
  window.__ksSizeKit = true;

  /* ---------- helpers ---------- */
  function trim1(n) { return (Math.round(n * 10) / 10).toString(); }
  function fillTxt(tpl, vars) {
    return String(tpl == null ? '' : tpl).replace(/\[(\w+)\]/g, function (m, k) { return vars[k] == null ? '' : String(vars[k]); });
  }
  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }
  function clear(n) { while (n && n.firstChild) n.removeChild(n.firstChild); }
  function reduced() { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
  function money(cents, fmt) {
    fmt = fmt || '${{amount}}';
    var n = (cents || 0) / 100;
    function f(dec, thou, pt) {
      var p = n.toFixed(dec).split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return p.length > 1 ? p[0] + pt + p[1] : p[0];
    }
    var m = /\{\{\s*(\w+)\s*\}\}/.exec(fmt), k = m ? m[1] : 'amount', out;
    switch (k) {
      case 'amount_no_decimals': out = f(0, ',', '.'); break;
      case 'amount_with_comma_separator': out = f(2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': out = f(0, '.', ','); break;
      case 'amount_with_apostrophe_separator': out = f(2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': out = f(0, ' ', '.'); break;
      case 'amount_with_space_separator': out = f(2, ' ', ','); break;
      case 'amount_with_period_and_space_separator': out = f(2, ' ', '.'); break;
      default: out = f(2, ',', '.');
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, out).replace(/<[^>]*>/g, '').trim();
  }
  /* the currency app converts .money spans already on the page */
  function refreshMoney() {
    if (window.baCurr && typeof window.baCurr.refreshConversion === 'function') {
      try { window.baCurr.refreshConversion(); } catch (e) {}
    }
  }
  function shortTitle(t) {
    return String(t || '').replace(/^Kick Speed\S*\s*/i, '')
      .replace(/\s*Roller\s+Skate\s+Shoes/i, '').replace(/\s*Heel\s+Wheels?\s+Roller\s+Shoes/i, ' Heel Wheel')
      .replace(/\s*Shoes\s+With\s+Wheels/i, '').replace(/\s*Roller\s+Shoes/i, '')
      .replace(/\s{2,}/g, ' ').trim() || String(t || '');
  }
  function isMe(p) { return !!p && /^(me|myself|my size|mine)$/i.test(String(p.name || '').trim()); }
  function cmTxt(cm, unit) { return unit === 'in' ? (cm / 2.54).toFixed(2) + ' in' : trim1(cm) + ' cm'; }
  /* table values always with one decimal: 22.0 cm */
  function cmTab(cm, unit) { return unit === 'in' ? (cm / 2.54).toFixed(2) + ' in' : (+cm).toFixed(1) + ' cm'; }

  /* ---------- the foot controls, shared by both widgets ----------
     input [data-kss-foot], optional slider [data-kss-range] with − / +
     [data-kss-inc], unit [data-kss-u], fit [data-kss-fit], socks
     [data-kss-socks], saved sizes [data-kss-who]/[data-kss-chips].
     Starts from the last measurement (KS.recall) or the one saved size. */
  function Controls(root, KS, defaults, onChange) {
    var $ = function (s) { return root.querySelector(s); };
    var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
    var input = $('[data-kss-foot]'), range = $('[data-kss-range]'), unitLab = $('[data-kss-unitlab]');
    var socksBox = $('[data-kss-socks]');
    var SV = KS.sizes && KS.sizes.on ? KS.sizes : null;
    var last = KS.recall ? (KS.recall() || {}) : {};
    var S = {
      unit: last.unit === 'in' || last.unit === 'cm' ? last.unit : (defaults.unit === 'in' ? 'in' : 'cm'),
      fit: KS.fits[last.fit] ? last.fit : (KS.fits[defaults.fit] ? defaults.fit : 'comfort'),
      foot: last.foot >= 10 && last.foot <= 40 ? Math.round(+last.foot * 10) / 10 : NaN,
      socks: !!last.socks,
      pid: ''
    };
    if (!(S.foot >= 10) && SV) {
      var list = SV.list();
      var kept = SV.pick ? SV.get(SV.pick()) : null;
      var p0 = kept || (list.length === 1 ? list[0] : null);
      if (p0) { S.foot = +p0.foot; S.fit = KS.fits[p0.fit] ? p0.fit : S.fit; S.socks = !!p0.socks; S.pid = p0.id; }
    }
    var DEF = 23;
    function ok() { return S.foot >= 10 && S.foot <= 35; }
    function person() {
      if (!SV) return null;
      var list = SV.list();
      for (var i = 0; i < list.length; i++) {
        var p = list[i];
        if (Math.abs(p.foot - S.foot) < 0.05 && p.fit === S.fit && !!p.socks === S.socks) return p;
      }
      return null;
    }
    /* the number field is as wide as its number, so the unit sits right after it */
    function fitWidth() {
      if (!input) return;
      var t = input.value || input.placeholder || '';
      input.style.width = (Math.max(2, t.replace(/[.,]/g, '').length) * 0.62 + (/[.,]/.test(t) ? 0.3 : 0) + 0.15) + 'em';
    }
    function paintInput() {
      if (!input) return;
      if (document.activeElement !== input) input.value = ok() ? (S.unit === 'in' ? (S.foot / 2.54).toFixed(2) : trim1(S.foot)) : '';
      fitWidth();
      input.step = S.unit === 'in' ? '0.05' : '0.1';
      input.placeholder = S.unit === 'in' ? (DEF / 2.54).toFixed(2) : DEF.toFixed(1);
      if (unitLab) unitLab.textContent = S.unit;
      root.classList.toggle('is-empty', !ok());
    }
    function paintRange() {
      if (!range) return;
      var cm = ok() ? S.foot : DEF;
      if (S.unit === 'in') { range.min = '5.5'; range.max = '11.8'; range.step = '0.05'; range.value = (cm / 2.54).toFixed(2); }
      else { range.min = '14'; range.max = '30'; range.step = '0.1'; range.value = trim1(cm); }
      var pct = (parseFloat(range.value) - parseFloat(range.min)) / (parseFloat(range.max) - parseFloat(range.min)) * 100;
      range.style.setProperty('--p', Math.max(0, Math.min(100, pct)) + '%');
      range.classList.toggle('is-unset', !ok());
    }
    function paintChips() {
      var box = $('[data-kss-who]'), chips = $('[data-kss-chips]');
      if (!box || !chips) return;
      var list = SV ? SV.list() : [];
      box.hidden = !list.length;
      clear(chips);
      var cur = person();
      list.forEach(function (p) {
        var b = el('button', 'kss__chip');
        b.type = 'button';
        b.setAttribute('data-kss-pid', p.id);
        b.setAttribute('aria-pressed', cur && cur.id === p.id ? 'true' : 'false');
        b.appendChild(el('b', null, p.name));
        b.appendChild(el('span', null, cmTxt(p.foot, S.unit)));
        chips.appendChild(b);
      });
    }
    function paintStatic() {
      $$('[data-kss-u]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-kss-u') === S.unit ? 'true' : 'false'); });
      $$('[data-kss-fit]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-kss-fit') === S.fit ? 'true' : 'false'); });
      if (socksBox) socksBox.checked = S.socks;
      paintInput(); paintRange(); paintChips();
    }
    var tRem = 0;
    function changed(remember) {
      paintStatic();
      onChange();
      if (remember !== false) {
        clearTimeout(tRem);
        tRem = setTimeout(function () {
          if (ok() && KS.remember) KS.remember({ foot: S.foot, fit: S.fit, socks: S.socks, unit: S.unit });
        }, 400);
      }
    }
    function setFoot(cm) { S.foot = isNaN(cm) ? NaN : Math.round(Math.max(10, Math.min(35, cm)) * 100) / 100; }

    if (input) {
      input.addEventListener('input', function () {
        fitWidth();
        var v = parseFloat(String(input.value).replace(',', '.'));
        setFoot(isNaN(v) ? NaN : (S.unit === 'in' ? v * 2.54 : v));
        paintRange(); paintChips(); onChange();
        clearTimeout(tRem);
        tRem = setTimeout(function () { if (ok() && KS.remember) KS.remember({ foot: S.foot, fit: S.fit, socks: S.socks, unit: S.unit }); }, 600);
      });
      input.addEventListener('blur', paintInput);
    }
    if (range) {
      range.addEventListener('input', function () {
        var v = parseFloat(range.value);
        setFoot(S.unit === 'in' ? v * 2.54 : v);
        paintInput(); paintRange(); paintChips(); onChange();
      });
      range.addEventListener('change', function () { changed(true); });
    }
    if (socksBox) socksBox.addEventListener('change', function () { S.socks = !!socksBox.checked; changed(true); });
    root.addEventListener('click', function (e) {
      var b = e.target && e.target.closest ? e.target.closest('button') : null;
      if (!b || !root.contains(b)) return;
      if (b.hasAttribute('data-kss-inc')) {
        var dir = +b.getAttribute('data-kss-inc');
        if (S.unit === 'in') {
          var inch = ok() ? Math.round((S.foot / 2.54 + dir * 0.05) * 20) / 20 : Math.round(DEF / 2.54 * 20) / 20;
          setFoot(inch * 2.54);
        } else setFoot(ok() ? Math.round((S.foot + dir * 0.1) * 10) / 10 : DEF);
        changed(true);
      } else if (b.hasAttribute('data-kss-u')) {
        S.unit = b.getAttribute('data-kss-u') === 'in' ? 'in' : 'cm';
        if (input) input.blur();
        changed(true);
      } else if (b.hasAttribute('data-kss-fit')) {
        S.fit = KS.fits[b.getAttribute('data-kss-fit')] ? b.getAttribute('data-kss-fit') : 'comfort';
        changed(true);
      } else if (b.hasAttribute('data-kss-pid') && SV) {
        var p = SV.get(b.getAttribute('data-kss-pid'));
        if (!p) return;
        S.foot = +p.foot; S.fit = KS.fits[p.fit] ? p.fit : 'comfort'; S.socks = !!p.socks; S.pid = p.id;
        if (SV.pick) SV.pick(p.id);
        changed(true);
      }
    });
    document.addEventListener('ks:sizes', paintChips);
    paintStatic();
    return {
      S: S, ok: ok, person: person, repaint: paintStatic,
      who: function (you) { var p = person(); return p && !isMe(p) ? p.name : (you || 'you'); },
      finderUrl: function (base, extra) {
        var u = base || '/pages/size-finder';
        if (!ok()) return u;
        return u + (u.indexOf('?') > -1 ? '&' : '?') + 'ks_foot=' + trim1(S.foot) + '&ks_fit=' + encodeURIComponent(S.fit) +
          (S.socks ? '&ks_socks=1' : '') + (extra || '');
      },
      productUrl: function (u) {
        if (!ok()) return u;
        return u + (u.indexOf('?') > -1 ? '&' : '?') + 'ks_foot=' + trim1(S.foot) + '&ks_fit=' + encodeURIComponent(S.fit) + (S.socks ? '&ks_socks=1' : '');
      }
    };
  }

  /* ===================== SHOP BY SIZE ===================== */
  function initShop(root, KS) {
    var cfg = {};
    try { cfg = JSON.parse(root.querySelector('[data-kss-config]').textContent); } catch (e) { cfg = {}; }
    var T = cfg.t || {};
    var res = root.querySelector('[data-kss-res]'), go = root.querySelector('[data-kss-go]'), cards = root.querySelector('[data-kss-cards]');
    var first = cards ? Array.prototype.map.call(cards.children, function (n) { return n.cloneNode(true); }) : [];
    var N = Math.max(2, Math.min(8, cfg.n || 4));
    var fam = '';
    var CAT = null, asked = false;

    function load() {
      if (asked) return;
      asked = true;
      KS.catalog(cfg.coll || 'all', function (c) { CAT = c; paint(); });
    }
    var ctl = Controls(root, KS, { unit: cfg.unit, fit: cfg.fit }, function () { load(); paintSoon(); });

    root.addEventListener('click', function (e) {
      var b = e.target && e.target.closest ? e.target.closest('[data-kss-fam]') : null;
      if (!b) return;
      fam = b.getAttribute('data-kss-fam') || '';
      Array.prototype.forEach.call(root.querySelectorAll('[data-kss-fam]'), function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      load();
      paint();
      if (KS.track) KS.track('ks_shop_size_range', { range: fam || 'all' });
    });

    var soonT = 0;
    function paintSoon() { clearTimeout(soonT); soonT = setTimeout(paint, 60); }

    function card(x, pick) {
      var r = x.r;
      var a = el('a', 'kss__card');
      a.href = ctl.productUrl(r.u);
      var im = el('span', 'kss__img');
      if (r.i) { var img = el('img'); img.src = r.i; img.alt = ''; img.loading = 'lazy'; img.decoding = 'async'; im.appendChild(img); }
      a.appendChild(im);
      a.appendChild(el('span', 'kss__name', shortTitle(r.t)));
      var meta = el('span', 'kss__meta' + (pick ? ' is-fit' : ''));
      meta.textContent = pick ? fillTxt(T.size || 'Your size US [size]', { size: pick.us, eu: pick.eu }) : (T.soon || '');
      a.appendChild(meta);
      if (r.p != null) { var pr = el('span', 'kss__price'); pr.appendChild(el('span', 'money', money(r.p, cfg.money))); a.appendChild(pr); }
      a.addEventListener('click', function () { if (KS.track) KS.track('ks_shop_size_card', { model: r.t, size: pick ? pick.us : null }); });
      return a;
    }
    function showCards(list) {
      clear(cards);
      list.forEach(function (n) { cards.appendChild(n); });
      refreshMoney();
    }

    function paint() {
      var S = ctl.S;
      var base = cfg.finder || '/pages/size-finder';
      var sys = fam ? '&ks_sys=' + fam : '';
      if (!ctl.ok()) {
        res.textContent = T.hint || '';
        res.className = 'kss__res';
        go.textContent = T.go0 || 'Open the size finder';
        go.href = base;
        if (CAT && fam) showCards(CAT.filter(function (x) { return x.r.f === fam && x.r.a && x.r.a.length > 1; }).slice(0, N).map(function (x) { return card(x, null); }));
        else showCards(first.map(function (n) { return n.cloneNode(true); }));
        return;
      }
      if (!CAT) { res.textContent = '…'; res.className = 'kss__res'; return; }
      var made = 0, count = {}, most = null, mostN = 0, fits = [];
      CAT.forEach(function (x) {
        if (fam && x.r.f !== fam) return;
        var r = KS.sizeFor(x.m, S.foot, { fit: S.fit, socks: S.socks });
        if (!r) return;
        var pick = r.best || r.bestAny;
        made++;
        var k = String(pick.us);
        count[k] = (count[k] || 0) + 1;
        if (count[k] > mostN) { mostN = count[k]; most = pick.us; }
        if (r.best) fits.push({ x: x, pick: r.best });
      });
      fits.sort(function (a, b) { return b.pick.score - a.pick.score || a.x.i - b.x.i; });
      if (made) {
        res.textContent = fillTxt(T.res || '[count] styles fit [who] · mostly US [size]', { count: made, size: most, who: ctl.who(T.you) });
        res.className = 'kss__res is-ok';
        go.textContent = fillTxt(T.go || 'Shop all [count] in my size', { count: made });
        go.href = ctl.finderUrl(base, '&ks_go=results' + sys);
        showCards(fits.slice(0, N).map(function (f) { return card(f.x, f.pick); }));
      } else {
        res.textContent = fillTxt(T.resNone || '', { foot: cmTxt(S.foot, S.unit) });
        res.className = 'kss__res is-none';
        go.textContent = T.go0 || 'Open the size finder';
        go.href = ctl.finderUrl(base, '');
        showCards([]);
      }
    }
    go.addEventListener('click', function () {
      if (KS.track) KS.track('ks_shop_size_go', { foot_cm: ctl.ok() ? ctl.S.foot : null, fit: ctl.S.fit, range: fam || 'all' });
    });
    /* fetch the model list as the module comes near the screen */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) { if (en.some(function (x) { return x.isIntersecting; })) { io.disconnect(); load(); } }, { rootMargin: '400px' });
      io.observe(root);
    } else load();
    if (ctl.ok()) load();
    paint();
  }

  /* ===================== SIZE GUIDE =====================
     The answer under the foot length and the marks on the tables are
     worked out per style with that style's own chart and KS.sizeFor(),
     exactly as the size finder does; a table that several charts share
     (same numbers) is only used for its "Your foot" column.            */
  function initGuide(root, KS) {
    var cfg = {};
    try { cfg = JSON.parse(root.querySelector('[data-ksg-config]').textContent); } catch (e) { cfg = {}; }
    var T = cfg.t || {}, FAMS = cfg.fams || {};
    var MODELS = [];
    try { MODELS = JSON.parse(root.querySelector('[data-ksg-models]').textContent) || []; } catch (e) { MODELS = []; }
    MODELS = MODELS.filter(function (m) { return m && KS.charts && KS.charts[m.c]; });
    var ans = root.querySelector('[data-ksg-ans]');

    function allOf(rows) { return '|' + rows.map(function (r) { return r[0]; }).join('|') + '|'; }
    var groups = Array.prototype.map.call(root.querySelectorAll('[data-ksg-grp]'), function (g) {
      var ids = String(g.getAttribute('data-ksg-grp') || '').split(',').filter(Boolean);
      var fam = g.getAttribute('data-ksg-fam') || '';
      var trs = Array.prototype.slice.call(g.querySelectorAll('tr[data-us]'));
      var rows = trs.map(function (tr) {
        return [parseFloat(tr.getAttribute('data-us')), parseFloat(tr.getAttribute('data-cm')), parseInt(tr.getAttribute('data-eu'), 10)];
      });
      return {
        el: g, fam: fam, trs: trs, rows: rows, you: g.querySelector('[data-ksg-you]'), cache: {},
        models: MODELS.filter(function (m) { return m.f === fam && ids.indexOf(m.c) > -1; })
      };
    });

    /* "Your foot" for one table and one fit: asks sizeFor() itself for
       every foot length from 10 to 35 cm in 1 mm steps and notes which
       size it gives, so these ranges ARE the recommendation, not a copy */
    function ranges(g, fit, socks) {
      var key = fit + '|' + (socks ? 1 : 0);
      if (g.cache[key]) return g.cache[key];
      var model = { rows: g.rows, avail: allOf(g.rows) };
      var out = {};
      for (var mm = 100; mm <= 350; mm++) {
        var f = mm / 10;
        var r = KS.sizeFor(model, f, { fit: fit, socks: socks });
        if (!r || !r.bestAny) continue;
        var k = String(r.bestAny.us);
        var o = out[k] || (out[k] = { min: f, max: f });
        if (f < o.min) o.min = f;
        if (f > o.max) o.max = f;
      }
      g.cache[key] = out;
      return out;
    }

    /* the size to order in one style: its own chart, every size it is made in */
    var chartModel = {};
    function pickFor(m, S) {
      var cm = chartModel[m.c] || (chartModel[m.c] = { rows: KS.charts[m.c], avail: allOf(KS.charts[m.c]) });
      var r = KS.sizeFor(cm, S.foot, { fit: S.fit, socks: S.socks });
      return r && r.bestAny ? r.bestAny : null;
    }
    /* styles grouped by the size they get: the same US with a different
       EU or inside length is a different size (Cloud LOW US 0.5 is EU 28,
       Spectra Glow MID US 0.5 is EU 29), so all three make the key.
       Sizes first, most styles first; "not made" last. */
    function buckets(models, S) {
      var by = {}, list = [];
      models.forEach(function (m) {
        var p = pickFor(m, S), k = p ? p.us + '|' + p.eu + '|' + p.cm : 'none';
        if (!by[k]) { by[k] = { pick: p, names: [], n: 0 }; list.push(by[k]); }
        by[k].names.push(m.t);
        by[k].n++;
      });
      return list.sort(function (a, b) {
        return (a.pick ? 0 : 1) - (b.pick ? 0 : 1) || b.n - a.n || (a.pick && b.pick ? a.pick.cm - b.pick.cm : 0);
      });
    }
    /* one line per size: a few styles are named, many are counted */
    function lineTxt(x, S, multi) {
      if (!multi) return sizeTxt(x.pick, S);
      return x.n <= 3 ? namesTxt(x.names) + ': ' + sizeTxt(x.pick, S) : sizeTxt(x.pick, S) + ' (' + stylesTxt(x.n) + ')';
    }
    function sizeTxt(p, S) {
      return p ? 'US ' + p.us + ' · EU ' + p.eu : fillTxt(T.youNone || 'Not made for [foot]', { foot: cmTxt(S.foot, S.unit) });
    }
    function namesTxt(names) {
      var a = names.slice(0, 3), more = names.length - a.length;
      if (more > 0) return a.join(', ') + ' ' + (T.and || 'and') + ' ' + more + ' ' + (T.more || 'more');
      if (a.length < 2) return a.join('');
      return a.slice(0, -1).join(', ') + ' ' + (T.and || 'and') + ' ' + a[a.length - 1];
    }
    function stylesTxt(n) { return n + ' ' + (n === 1 ? (T.style || 'style') : (T.styles || 'styles')); }

    var ctl = Controls(root, KS, { unit: 'cm', fit: 'comfort' }, function () { paintSoon(); usedSoon(); });
    var soonT = 0;
    function paintSoon() { clearTimeout(soonT); soonT = setTimeout(paint, 40); }

    /* analytics: once the shopper stops changing their foot, fit or socks
       for 1.5 s, one ks_guide_size event (not one per keystroke), and
       only when that combination has not been reported on this page yet */
    var usedT = 0, usedLast = '';
    function usedSoon() {
      clearTimeout(usedT);
      usedT = setTimeout(function () {
        if (!ctl.ok() || !KS.track) return;
        var S = ctl.S, key = S.foot.toFixed(1) + '|' + S.fit + '|' + (S.socks ? 1 : 0);
        if (key === usedLast) return;
        usedLast = key;
        KS.track('ks_guide_size', { foot_cm: Math.round(S.foot * 10) / 10, fit: S.fit, socks: !!S.socks });
      }, 1500);
    }

    function paintAnswer(S, fitName) {
      if (!ans) return;
      clear(ans);
      if (!ctl.ok()) { ans.appendChild(el('p', 'kss__res', T.hint || '')); return; }
      ans.appendChild(el('p', 'kss__res is-ok', fillTxt(T.summary || 'Your size for [foot] · [fit]', { foot: cmTxt(S.foot, S.unit), fit: fitName })));
      var ul = el('ul', 'ksg__sum');
      ['popout', 'heel'].forEach(function (fam) {
        var ms = MODELS.filter(function (m) { return m.f === fam; });
        if (!ms.length) return;
        var b = buckets(ms, S), li = el('li'), multi = b.length > 1;
        var a = el('a', 'ksg__sumF', FAMS[fam] || fam);
        a.href = '#ksg-' + fam;
        li.appendChild(a);
        li.appendChild(el('span', 'ksg__sumV' + (b[0].pick ? '' : ' is-none'), lineTxt(b[0], S, multi)));
        b.slice(1).forEach(function (x) {
          li.appendChild(el('span', 'ksg__sumX', lineTxt(x, S, multi)));
        });
        ul.appendChild(li);
      });
      ans.appendChild(ul);
      if (cfg.finder && T.shop) {
        var lk = el('a', 'ksg__shop', T.shop + ' →');
        lk.href = ctl.finderUrl(cfg.finder, '&ks_go=results');
        lk.addEventListener('click', function () { if (KS.track) KS.track('ks_guide_shop', { foot_cm: Math.round(S.foot * 10) / 10, fit: S.fit }); });
        ans.appendChild(lk);
      }
    }

    function paint() {
      var S = ctl.S, u = S.unit;
      var fitName = (KS.fits[S.fit] || {}).label || S.fit;
      Array.prototype.forEach.call(root.querySelectorAll('[data-ksg-fitlab]'), function (n) { n.textContent = '(' + fitName + ')'; });
      groups.forEach(function (g) {
        var R = ranges(g, S.fit, S.socks);
        var b = ctl.ok() ? buckets(g.models, S) : [];
        var mine = {};
        /* inside one table a US size always has the same EU and length */
        b.forEach(function (x) { if (x.pick) mine[String(x.pick.us)] = true; });
        g.trs.forEach(function (tr, i) {
          var us = g.rows[i][0];
          var o = R[String(us)];
          var cell = tr.querySelector('[data-ksg-foot]');
          if (cell) cell.textContent = o ? (u === 'in' ? (o.min / 2.54).toFixed(2) + '–' + (o.max / 2.54).toFixed(2) + ' in' : o.min.toFixed(1) + '–' + o.max.toFixed(1) + ' cm') : '–';
          var ins = tr.querySelector('[data-ksg-in]');
          if (ins) ins.textContent = cmTab(parseFloat(ins.getAttribute('data-cm')), u);
          tr.classList.toggle('is-you', !!mine[String(us)]);
        });
        if (!g.you) return;
        clear(g.you);
        if (!ctl.ok() || !b.length) { g.you.hidden = true; return; }
        g.you.hidden = false;
        g.you.classList.toggle('is-none', !b[0].pick && b.length === 1);
        g.you.classList.toggle('is-multi', b.length > 1);
        if (b.length === 1) {
          g.you.textContent = b[0].pick ? fillTxt(T.you || 'Your size: US [size] · EU [eu]', { size: b[0].pick.us, eu: b[0].pick.eu })
                                        : fillTxt(T.youNone || 'Not made for [foot]', { foot: cmTxt(S.foot, u) });
        } else {
          b.forEach(function (x) { g.you.appendChild(el('span', null, lineTxt(x, S, true))); });
        }
      });
      paintAnswer(S, fitName);
      paintMini();
    }

    /* the fit cards show the room the core adds */
    Array.prototype.forEach.call(root.querySelectorAll('[data-ksg-room]'), function (s) {
      var f = KS.fits[s.getAttribute('data-ksg-room')];
      if (f) s.textContent = '+' + trim1(f.target);
    });

    /* a small bar at the top while the tables are scrolled through */
    var me = root.querySelector('[data-ksg-me]'), mini = root.querySelector('[data-ksg-mini]');
    var miniText = root.querySelector('[data-ksg-mini-text]'), miniGo = root.querySelector('[data-ksg-mini-go]');
    var past = false;
    /* below the theme's header when it sticks to the top (it slides in
       and out, so it is watched and the bar follows it) */
    var hdr = document.getElementById('SiteHeader') || document.querySelector('.site-header');
    if (hdr && 'MutationObserver' in window) {
      new MutationObserver(function () { setTimeout(paintMini, 40); setTimeout(paintMini, 400); })
        .observe(hdr, { attributes: true, attributeFilter: ['class', 'style'] });
    }
    function topOffset() {
      if (hdr) {
        var hs = window.getComputedStyle(hdr), hr = hdr.getBoundingClientRect();
        if ((hs.position === 'fixed' || hs.position === 'sticky') && hr.top <= 1 && hr.bottom > 0) return Math.min(160, Math.round(hr.bottom));
      }
      var x = window.innerWidth / 2, y = 2, n = document.elementFromPoint(x, y), off = 0;
      while (n && n !== document.body && n !== document.documentElement) {
        if (n === mini) return 0;
        var cs = window.getComputedStyle(n);
        if (cs.position === 'fixed' || cs.position === 'sticky') { off = Math.max(off, n.getBoundingClientRect().bottom); }
        n = n.parentElement;
      }
      return Math.max(0, Math.min(160, Math.round(off)));
    }
    function paintMini() {
      if (!mini) return;
      var lastG = groups.length ? groups[groups.length - 1].el.getBoundingClientRect() : null;
      var inTables = past && lastG && lastG.bottom > 120;
      if (!inTables) { mini.hidden = true; return; }
      mini.style.top = (topOffset() + 8) + 'px';
      miniText.textContent = ctl.ok()
        ? fillTxt(T.mini || 'Your foot [foot] · [fit]', { foot: cmTxt(ctl.S.foot, ctl.S.unit), fit: (KS.fits[ctl.S.fit] || {}).label || '' })
        : (T.hint || '');
      mini.hidden = false;
    }
    if (me && mini && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        en.forEach(function (x) { past = !x.isIntersecting && x.boundingClientRect.top < 0; });
        paintMini();
      }).observe(me);
      window.addEventListener('scroll', function () { if (past) paintMini(); }, { passive: true });
      miniGo.addEventListener('click', function () {
        var y = me.getBoundingClientRect().top + window.pageYOffset - topOffset() - 12;
        window.scrollTo({ top: Math.max(0, y), behavior: reduced() ? 'auto' : 'smooth' });
        var inp = me.querySelector('[data-kss-foot]');
        if (inp) setTimeout(function () { try { inp.focus({ preventScroll: true }); } catch (e) {} }, 450);
      });
    }
    paint();
  }

  /* ---------- start ---------- */
  function start(scope, tries) {
    var KS = window.KSFinder;
    if (!KS || typeof KS.sizeFor !== 'function' || typeof KS.catalog !== 'function') {
      if ((tries || 0) < 40) setTimeout(function () { start(scope, (tries || 0) + 1); }, 150);
      return;
    }
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-kss]'), function (r) {
      if (r.getAttribute('data-kss-ready') === '1') return;
      r.setAttribute('data-kss-ready', '1');
      initShop(r, KS);
    });
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-ksg]'), function (r) {
      if (r.getAttribute('data-ksg-ready') === '1') return;
      r.setAttribute('data-ksg-ready', '1');
      initGuide(r, KS);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { start(document, 0); });
  else start(document, 0);
  document.addEventListener('shopify:section:load', function (e) { start(e.target, 0); });
})();
